import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/company/CompanyRolesAndPermissionsForm.scss';
import connect from 'react-redux/es/connect/connect';
import autobind from 'autobind-decorator';
import classNames from 'classnames';
import UncheckedIcon from '../../assets/images/unchecked-15x15.svg';
import CheckedIcon from '../../assets/images/checked-15x15.svg';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { __ } from '../../core/utils';
import Checkbox from '../../components/Checkbox';
import Select from '../../components/Select';

@reduxForm({
  form: 'profile.company_and_roles_permissions',
  enableReinitialize: true,
})
@connect((state) => ({
  values: getFormValues('profile.company_and_roles_permissions')(state),
  state: state,
}))
class CompanyRolesAndPermissionsForm extends Component {
  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  @autobind
  _togglePermission(permission) {
    const perms = this.props.values?.permissions || {};

    const newPermissions = _.has(perms, permission.id)
      ? _.omit(perms, permission.id)
      : { ...perms, [permission.id]: permission.name };

    this.props.change('permissions', newPermissions);
    this.props.touch('permissions');
    this.props.blur('permissions');
  }

  render() {
    const {
      listPermissions,
      user_id,
      values: { permissions },
    } = this.props;

    const roles = [
      { id: 'view', label: 'View' },
      { id: 'create', label: 'Create' },
      { id: 'update', label: 'Update' },
      { id: 'delete', label: 'Delete' },
      // { id: 'assign', label: 'Assign' },
      // { id: 'approve', label: 'Approve' },
      // { id: 'read', label: 'Read' },
    ];

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.heading}>
          {/* <span className={styles.type}>
            {__('company_and_roles_permissions.columns.type')}
          </span>
          <span>{__('company_and_roles_permissions.columns.view')}</span>
          <span>{__('company_and_roles_permissions.columns.create')}</span>
          <span>{__('company_and_roles_permissions.columns.update')}</span>
          <span>{__('company_and_roles_permissions.columns.delete')}</span>
          <span>{__('company_and_roles_permissions.columns.assignee')}</span> */}

          <span className={styles.type}>permission</span>

          {_.map(roles, (role) => {
            return <span>{role.label}</span>;
          })}
        </div>
        <div className={styles.content}>
          {_.map(listPermissions, (group, i) => {
            return (
              <div className={styles.group} key={i}>
                <div className={styles.groupHeading}>
                  <div className={styles.name}>
                    {group.name}
                    {/* {__(
                      'company_and_roles_permissions.settings.groups.' +
                        group.name
                    )} */}
                  </div>

                  {_.map(roles, (role) => {
                    const permission = _.find(
                      group.permissions,
                      (p) => _.first(_.split(p.name, '.')) === role.id
                    );

                    return (
                      <span key={role.id}>
                        {permission ? (
                          _.get(permissions, permission.id) ? (
                            <CheckedIcon
                              className={classNames(
                                styles.checked,
                                !user_id && styles.disabled
                              )}
                              // onClick={() => this._togglePermission(permission)}
                              onClick={(e) => e.preventDefault()}
                            />
                          ) : (
                            <UncheckedIcon
                              className={classNames(
                                styles.unchecked,
                                !user_id && styles.disabled
                              )}
                              // onClick={() => this._togglePermission(permission)}
                              onClick={(e) => e.preventDefault()}
                            />
                          )
                        ) : (
                          <span className={styles.emptyCell} />
                        )}
                      </span>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Form>
    );
  }
}

export default CompanyRolesAndPermissionsForm;
